// Shared constants for outreach service
// This module contains all constants used across outreach modules

// Base paths for outreach data
export const OUTREACH_DOC_PATH = "outreach/data";